export default __webpack_public_path__ + "static/media/loader.5f1b3842.svg";